/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LabelDefs from './..\\..\\..\\com\\atproto\\label\\defs.defs.js'
import * as LabelerDefs from './defs.defs.js'
import * as ModerationDefs from './..\\..\\..\\com\\atproto\\moderation\\defs.defs.js'

const $nsid = 'app.bsky.labeler.service'

type $nsid = typeof $nsid

export { $nsid }

/** A declaration of the existence of labeler service. */
type Main = {
  $type: 'app.bsky.labeler.service'
  labels?: l.$Typed<LabelDefs.SelfLabels> | l.Unknown$TypedObject
  policies: LabelerDefs.LabelerPolicies
  createdAt: l.DatetimeString

  /**
   * The set of report reason 'codes' which are in-scope for this service to review and action. These usually align to policy categories. If not defined (distinct from empty array), all reason types are allowed.
   */
  reasonTypes?: ModerationDefs.ReasonType[]

  /**
   * The set of subject types (account, record, etc) this service accepts reports on.
   */
  subjectTypes?: ModerationDefs.SubjectType[]

  /**
   * Set of record types (collection NSIDs) which can be reported to this service. If not defined (distinct from empty array), default is any record type.
   */
  subjectCollections?: l.NsidString[]
}

export type { Main }

/** A declaration of the existence of labeler service. */
const main = /*#__PURE__*/ l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  /*#__PURE__*/ l.object({
    labels: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<LabelDefs.SelfLabels>(
            (() => LabelDefs.selfLabels) as any,
          ),
        ],
        false,
      ),
    ),
    policies: /*#__PURE__*/ l.ref<LabelerDefs.LabelerPolicies>(
      (() => LabelerDefs.labelerPolicies) as any,
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    reasonTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ModerationDefs.ReasonType>(
          (() => ModerationDefs.reasonType) as any,
        ),
      ),
    ),
    subjectTypes: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ModerationDefs.SubjectType>(
          (() => ModerationDefs.subjectType) as any,
        ),
      ),
    ),
    subjectCollections: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string({ format: 'nsid' })),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
